/** Attribute on the portaled emoji picker shell. */
export const EMOJI_PICKER_ATTR = "data-emoji-picker";

function pointInRect(x, y, rect) {
  return (
    x >= rect.left &&
    x <= rect.right &&
    y >= rect.top &&
    y <= rect.bottom
  );
}

/**
 * True when an event originated inside an emoji-mart picker (incl. shadow DOM).
 * Uses composedPath, DOM closest, and a clientX/Y hit-test against open shells.
 */
export function eventFromEmojiPicker(event) {
  const original = event?.detail?.originalEvent ?? event;
  const path =
    typeof original?.composedPath === "function" ? original.composedPath() : [];
  for (const node of path) {
    if (!node || node.nodeType !== 1) continue;
    if (node.hasAttribute?.(EMOJI_PICKER_ATTR)) return true;
    if (node.tagName === "EM-EMOJI-PICKER") return true;
  }
  const target = original?.target ?? event?.target;
  if (target?.closest?.(`[${EMOJI_PICKER_ATTR}]`)) return true;
  if (target?.closest?.("em-emoji-picker")) return true;

  // Shadow-DOM / retargeting fallback: hit-test open picker panels
  const x = original?.clientX ?? event?.clientX;
  const y = original?.clientY ?? event?.clientY;
  if (typeof x === "number" && typeof y === "number" && typeof document !== "undefined") {
    const shells = document.querySelectorAll(`[${EMOJI_PICKER_ATTR}]`);
    for (const el of shells) {
      if (pointInRect(x, y, el.getBoundingClientRect())) return true;
    }
  }

  // Focus events often lack coordinates; check activeElement / relatedTarget.
  if (typeof document !== "undefined") {
    const candidates = [
      document.activeElement,
      original?.relatedTarget,
      event?.relatedTarget,
    ];
    for (const node of candidates) {
      if (!node || node.nodeType !== 1) continue;
      if (node.closest?.(`[${EMOJI_PICKER_ATTR}]`)) return true;
      if (node.closest?.("em-emoji-picker")) return true;
      if (node.tagName === "EM-EMOJI-PICKER") return true;
    }
  }
  return false;
}

export function eventFromHoverCard(event) {
  const original = event?.detail?.originalEvent ?? event;
  const path =
    typeof original?.composedPath === "function" ? original.composedPath() : [];
  for (const node of path) {
    if (!node || node.nodeType !== 1) continue;
    if (node.hasAttribute?.("data-radix-hover-card-content")) return true;
  }
  const target = original?.target ?? event?.target;
  if (target?.closest?.("[data-radix-hover-card-content]")) return true;
  return false;
}

export function eventFromDialogSafePortal(event) {
  return eventFromEmojiPicker(event) || eventFromHoverCard(event);
}
